import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { getKeycloakContext } from '../auth/auth.utils';
import { environment } from 'src/environments/environment';

const BASE_API_URL = environment.apiURL;
const snagReportSettings = environment.snagReportSettings;

@Injectable()
export class TenantIdInterceptor implements HttpInterceptor {
	private authService = inject( AuthService );

  intercept ( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
    const tenantId = this.determineTenantId()

	if ( req.url.includes( snagReportSettings.api.url ) ) return next.handle( req );
	if ( !req.url.includes( BASE_API_URL ) ) return next.handle( req );

	if ( !tenantId ) {
		return next.handle( req );
	}

    const clonedRequest = req.clone( {
		setHeaders: {
			'x-tenant-id': tenantId
		}
    } );

    return next.handle( clonedRequest );
  }

  private determineTenantId (): string | null {
	const keycloakContext = getKeycloakContext()
	if( keycloakContext && keycloakContext.clientId ) {
		return keycloakContext.clientId
	}
	if( this.authService.user && this.authService.user.client ) {
		return this.authService.user.client
	}
	return null
  }
}
